'use client';

import { c as _c } from "react/compiler-runtime";
import { useSearchParams } from 'next/navigation';
import { useEffect, useEffectEvent, useRef } from 'react';
import { useDebouncedValue } from '@/shared/hooks/useDebouncedValue';
import { buscarPartesDocumentosPadrao, carregarContextoDocumentosPadrao, carregarDetalheDocumentoPadrao, carregarDocumentosPadrao, carregarMaisUsosDocumentoPadrao, fecharDetalheDocumentoPadrao, definirAbaDocumentosPadrao, definirFiltrosDocumentosPadrao, definirPaginaDocumentosPadrao, limparFiltrosDocumentosPadrao, selectDocumentoPadraoCarregandoDetalhe, selectDocumentoPadraoDetalhe, selectDocumentoPadraoPaginaUsos, selectDocumentosPadraoAba, selectDocumentosPadraoBuscandoPartes, selectDocumentosPadraoContadores, selectDocumentosPadraoContexto, selectDocumentosPadraoDiasAviso, selectDocumentosPadraoErro, selectDocumentosPadraoFiltros, selectDocumentosPadraoItens, selectDocumentosPadraoPaginacao, selectDocumentosPadraoPartes, selectDocumentosPadraoReferencia, selectDocumentosPadraoResumoValidade, selectDocumentosPadraoSalvando, selectDocumentosPadraoSetores, selectDocumentosPadraoStatus, selectDocumentosPadraoTemFiltrosAtivos } from '@/features/documentosPadrao/store';
import type { DocumentosPadraoAba, DocumentosPadraoFiltros } from '@/features/documentosPadrao/types/documentosPadraoTypes';
import { useToast } from '@/shared/providers';
import { useAppDispatch, useAppSelector } from '@/store/hooks';

/** Busca é digitação: sem debounce, cada tecla vira uma consulta paginada no servidor. */
const DEBOUNCE_BUSCA_MS = 350;
export function useDocumentosPadrao() {
  const $ = _c(76);
  const dispatch = useAppDispatch();
  const toast = useToast();
  const status = useAppSelector(selectDocumentosPadraoStatus);
  const erro = useAppSelector(selectDocumentosPadraoErro);
  const salvando = useAppSelector(selectDocumentosPadraoSalvando);
  const itens = useAppSelector(selectDocumentosPadraoItens);
  const aba = useAppSelector(selectDocumentosPadraoAba);
  const filtros = useAppSelector(selectDocumentosPadraoFiltros);
  const paginacao = useAppSelector(selectDocumentosPadraoPaginacao);
  const contadores = useAppSelector(selectDocumentosPadraoContadores);
  const resumo = useAppSelector(selectDocumentosPadraoResumoValidade);
  const setores = useAppSelector(selectDocumentosPadraoSetores);
  const contexto = useAppSelector(selectDocumentosPadraoContexto);
  const referencia = useAppSelector(selectDocumentosPadraoReferencia);
  const diasAviso = useAppSelector(selectDocumentosPadraoDiasAviso) ?? undefined;
  const temFiltrosAtivos = useAppSelector(selectDocumentosPadraoTemFiltrosAtivos);
  const partes = useAppSelector(selectDocumentosPadraoPartes);
  const buscandoPartes = useAppSelector(selectDocumentosPadraoBuscandoPartes);
  const detalhe = useAppSelector(selectDocumentoPadraoDetalhe);
  const carregandoDetalhe = useAppSelector(selectDocumentoPadraoCarregandoDetalhe);
  const paginaUsos = useAppSelector(selectDocumentoPadraoPaginaUsos);
  const t0 = useSearchParams();
  let t1;
  if ($[0] !== t0) {
    t1 = t0.get("documento");
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const documentoDoLink = t1;
  const contextoCarregado = useRef(false);
  let t2;
  if ($[2] !== filtros.busca) {
    t2 = filtros.busca.trim();
    $[2] = filtros.busca;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const buscaDebounced = useDebouncedValue(t2, DEBOUNCE_BUSCA_MS);
  const {
    tipo,
    setorId,
    produto,
    validade
  } = filtros;
  let t3;
  let t4;
  if ($[4] !== dispatch) {
    t3 = () => {
      if (contextoCarregado.current) {
        return;
      }
      contextoCarregado.current = true;
      dispatch(carregarContextoDocumentosPadrao());
    };
    t4 = [dispatch];
    $[4] = dispatch;
    $[5] = t3;
    $[6] = t4;
  } else {
    t3 = $[5];
    t4 = $[6];
  }
  useEffect(t3, t4);
  let t5;
  if ($[7] !== dispatch) {
    t5 = () => {
      dispatch(carregarDocumentosPadrao());
    };
    $[7] = dispatch;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== aba || $[10] !== buscaDebounced || $[11] !== dispatch || $[12] !== paginacao.page || $[13] !== produto || $[14] !== setorId || $[15] !== tipo || $[16] !== validade) {
    t6 = [dispatch, aba, buscaDebounced, tipo, setorId, produto, validade, paginacao.page];
    $[9] = aba;
    $[10] = buscaDebounced;
    $[11] = dispatch;
    $[12] = paginacao.page;
    $[13] = produto;
    $[14] = setorId;
    $[15] = tipo;
    $[16] = validade;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  useEffect(t5, t6);
  const carregando = status === "loading" || status === "idle";
  const bibliotecaVazia = status === "succeeded" && contadores.todos === 0 && contadores.arquivados === 0;
  let t7;
  if ($[18] !== dispatch) {
    t7 = () => {
      dispatch(definirAbaDocumentosPadrao("todos"));
      dispatch(definirFiltrosDocumentosPadrao({
        validade: "criticas"
      }));
    };
    $[18] = dispatch;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  const verSomenteValidadeCritica = t7;
  let t8;
  if ($[20] !== dispatch || $[21] !== toast) {
    t8 = id => dispatch(carregarDetalheDocumentoPadrao(id)).unwrap().catch(erro_0 => {
      toast.showError("N\xE3o foi poss\xEDvel abrir o documento", typeof erro_0 === "string" ? erro_0 : undefined);
    });
    $[20] = dispatch;
    $[21] = toast;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  const abrirDetalhe = t8;
  let t9;
  if ($[23] !== abrirDetalhe) {
    t9 = id_0 => abrirDetalhe(id_0);
    $[23] = abrirDetalhe;
    $[24] = t9;
  } else {
    t9 = $[24];
  }
  const abrirDocumentoDoLink = useEffectEvent(t9);
  let t10;
  if ($[25] !== abrirDocumentoDoLink || $[26] !== documentoDoLink) {
    t10 = () => {
      if (documentoDoLink) {
        abrirDocumentoDoLink(documentoDoLink);
      }
    };
    $[25] = abrirDocumentoDoLink;
    $[26] = documentoDoLink;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== documentoDoLink) {
    t11 = [documentoDoLink];
    $[28] = documentoDoLink;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  useEffect(t10, t11);
  let t12;
  if ($[30] !== dispatch) {
    t12 = busca => dispatch(buscarPartesDocumentosPadrao(busca));
    $[30] = dispatch;
    $[31] = t12;
  } else {
    t12 = $[31];
  }
  let t13;
  if ($[32] !== dispatch || $[33] !== paginaUsos) {
    t13 = id_1 => dispatch(carregarMaisUsosDocumentoPadrao({
      id: id_1,
      page: paginaUsos + 1
    }));
    $[32] = dispatch;
    $[33] = paginaUsos;
    $[34] = t13;
  } else {
    t13 = $[34];
  }
  let t14;
  if ($[35] !== dispatch) {
    t14 = () => dispatch(fecharDetalheDocumentoPadrao());
    $[35] = dispatch;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== dispatch) {
    t15 = () => dispatch(limparFiltrosDocumentosPadrao());
    $[37] = dispatch;
    $[38] = t15;
  } else {
    t15 = $[38];
  }
  let t16;
  if ($[39] !== dispatch) {
    t16 = () => dispatch(carregarDocumentosPadrao());
    $[39] = dispatch;
    $[40] = t16;
  } else {
    t16 = $[40];
  }
  let t17;
  let t18;
  let t19;
  if ($[41] !== dispatch) {
    t17 = proximaAba => dispatch(definirAbaDocumentosPadrao(proximaAba));
    t18 = parcial => dispatch(definirFiltrosDocumentosPadrao(parcial));
    t19 = pagina => dispatch(definirPaginaDocumentosPadrao(pagina));
    $[41] = dispatch;
    $[42] = t17;
    $[43] = t18;
    $[44] = t19;
  } else {
    t17 = $[42];
    t18 = $[43];
    t19 = $[44];
  }
  let t20;
  if ($[45] !== aba || $[46] !== abrirDetalhe || $[47] !== bibliotecaVazia || $[48] !== buscandoPartes || $[49] !== carregando || $[50] !== carregandoDetalhe || $[51] !== contadores || $[52] !== contexto || $[53] !== detalhe || $[54] !== diasAviso || $[55] !== erro || $[56] !== filtros || $[57] !== itens || $[58] !== paginacao.page || $[59] !== paginacao.totalPages || $[60] !== partes || $[61] !== referencia || $[62] !== resumo || $[63] !== salvando || $[64] !== setores || $[65] !== t12 || $[66] !== t13 || $[67] !== t14 || $[68] !== t15 || $[69] !== t16 || $[70] !== t17 || $[71] !== t18 || $[72] !== t19 || $[73] !== temFiltrosAtivos || $[74] !== verSomenteValidadeCritica) {
    t20 = {
      aba,
      abrirDetalhe,
      bibliotecaVazia,
      buscandoPartes,
      buscarPartes: t12,
      carregandoDetalhe,
      carregarMaisUsos: t13,
      detalhe,
      diasAviso,
      fecharDetalhe: t14,
      partes,
      carregando,
      contadores,
      contexto,
      erro,
      filtros,
      itensDaPagina: itens,
      limparFiltros: t15,
      pagina: paginacao.page,
      recarregar: t16,
      referencia,
      resumo,
      salvando,
      setores,
      temFiltrosAtivos,
      totalPaginas: paginacao.totalPages,
      trocarAba: t17,
      atualizarFiltros: t18,
      irParaPagina: t19,
      verSomenteValidadeCritica
    };
    $[45] = aba;
    $[46] = abrirDetalhe;
    $[47] = bibliotecaVazia;
    $[48] = buscandoPartes;
    $[49] = carregando;
    $[50] = carregandoDetalhe;
    $[51] = contadores;
    $[52] = contexto;
    $[53] = detalhe;
    $[54] = diasAviso;
    $[55] = erro;
    $[56] = filtros;
    $[57] = itens;
    $[58] = paginacao.page;
    $[59] = paginacao.totalPages;
    $[60] = partes;
    $[61] = referencia;
    $[62] = resumo;
    $[63] = salvando;
    $[64] = setores;
    $[65] = t12;
    $[66] = t13;
    $[67] = t14;
    $[68] = t15;
    $[69] = t16;
    $[70] = t17;
    $[71] = t18;
    $[72] = t19;
    $[73] = temFiltrosAtivos;
    $[74] = verSomenteValidadeCritica;
    $[75] = t20;
  } else {
    t20 = $[75];
  }
  return t20;
}